import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import macheteDux from 'src/redux/machete';
import appDux from 'src/redux/app';
import splitDux from 'src/redux/split';
import uiDux from 'src/redux/ui';
import Spinner from 'src/components/Spinner';
import DesignExtendedSidebar from 'src/components/DesignSidebar/DesignExtendedSidebar/DesignExtendedSidebar';
import AllCategories from './AllCategories';
import Breadcrumbs from './Breadcrumbs';
import SelectedElements from './SelectedElements';
import SplitSidebar from './SplitTools/SplitSidebar';
import { Container, ContentContainer, Content } from './DesignSidebar.styles';

const mapStateToProps = (state) => ({
  selectedElementCount: macheteDux.selectors.getSelectedElementCount(state),
  isSplitToolActive: splitDux.selectors.isSplitToolActive(state),
  activeEditingAttribute: appDux.selectors.getActiveEditingAttribute(state),
  isProductCatalogInitialized: appDux.selectors.isProductCatalogInitialized(
    state,
  ),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeExtendedSidebar: uiDux.actions.closeExtendedSidebar,
    },
    dispatch,
  );

export class DesignSidebar extends PureComponent {
  static propTypes = {
    activeEditingAttribute: PropTypes.object.isRequired,
    closeExtendedSidebar: PropTypes.func.isRequired,
    selectedElementCount: PropTypes.number.isRequired,
    isSplitToolActive: PropTypes.bool.isRequired,
    isProductCatalogInitialized: PropTypes.bool.isRequired,
  };

  render() {
    const {
      activeEditingAttribute,
      closeExtendedSidebar,
      selectedElementCount,
      isSplitToolActive,
      isProductCatalogInitialized,
    } = this.props;

    if (isSplitToolActive) return <SplitSidebar />;
    if (!isProductCatalogInitialized) return <Spinner color="#767676" />;

    const DesignSidebarContainer = Container;
    const DesignSidebarContentContainer = ContentContainer;
    const DesignSidebarContent = Content;

    return (
      <DesignSidebarContainer data-selenium="designSidebar">
        <Breadcrumbs />
        <DesignSidebarContentContainer>
          <DesignSidebarContent
            data-selenium="designSidebarContent"
            onClick={closeExtendedSidebar}
          >
            {selectedElementCount > 0 ? (
              <SelectedElements />
            ) : (
              <AllCategories />
            )}
          </DesignSidebarContent>
        </DesignSidebarContentContainer>
        {activeEditingAttribute && <DesignExtendedSidebar />}
      </DesignSidebarContainer>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DesignSidebar);
